module.exports = __webpack_public_path__ + "img/Home page-1.f3055446.png";